/* Estado de carga para 'Comprar ahora' (ago-2026).
   El boton unbranded de dynamic checkout navega al checkout sin mostrar
   ninguna senal de progreso; en conexiones lentas eso son 2-5s de silencio
   (Clarity: 175 dead clicks/semana). Solo aplica al boton unbranded: los
   wallets (Shop Pay, etc.) abren su propio panel y no deben tocarse. */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('.shopify-payment-button__button--unbranded');
      if (!btn || btn.disabled || btn.classList.contains('mp-loading')) return;
      btn.classList.add('mp-loading');
      // Red de seguridad: si en 8s no navego (error, popup bloqueado), se restaura.
      setTimeout(function () {
        btn.classList.remove('mp-loading');
      }, 8000);
    },
    true
  );
})();

/* CRO 15-oct-2026: el popup del juego (Halloween hoy, el que venga despues) NO debe
   interrumpir la primera pagina de una visita que viene de pauta (Meta / Google cpc):
   en Clarity es el #1 generador de toques muertos y esas sesiones ya rebotan 70-80%.
   Regla: en trafico pagado el popup se difiere hasta la 2a pagina, el 50% de scroll
   o 45 s de permanencia (lo que pase primero). Trafico directo/organico/email: sin cambio.
   Mecanismo: el juego expone window.MpHalloween.abrir() y respeta sessionStorage
   mp_hw_no='1' (lo revisa justo antes de abrir). Aqui se pone esa llave solo mientras
   dura la espera (mp_hw_hold) y se quita al liberar. No se toca el archivo del juego. */
(function () {
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function ssDel(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  function ls(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  var pv = parseInt(ss('mp_pv') || '0', 10) + 1;
  ssSet('mp_pv', String(pv));

  /* Si una pagina anterior dejo la llave puesta (navego antes de liberar), soltarla SIEMPRE primero */
  if (ss('mp_hw_hold') === '1') { ssDel('mp_hw_hold'); ssDel('mp_hw_no'); }

  if (pv === 1 && !ss('mp_pauta')) {
    var q = location.search.toLowerCase();
    var med = (ss('mp_utm_medium') || '').toLowerCase();
    var src = (ss('mp_utm_source') || '').toLowerCase();
    var ref = (document.referrer || '').toLowerCase();
    var pauta = /gclid=|fbclid=|ttclid=/.test(q) ||
      /^(paid|cpc|pmax|paidsocial|paid_social|display|social)$/.test(med) ||
      /^(ig|fb|instagram|facebook|meta|tiktok)$/.test(src) ||
      /instagram\.com|facebook\.com|fb\.com|tiktok\.com/.test(ref);
    ssSet('mp_pauta', pauta ? '1' : '0');
  }

  var juego = window.MpHalloween;
  if (!juego || typeof juego.abrir !== 'function') return;
  if (ss('mp_pauta') !== '1' || pv >= 2) return;      /* sin pauta, o ya es la 2a pagina: el juego sigue su curso */
  if (ss('mp_hw_no') === '1') return;                 /* la clienta ya lo cerro antes: respetar */
  if (ls('mp_hw_jugo') === '1' || ls('mp_hw_premio')) return; /* ya jugo: el juego no abre y nosotros tampoco */

  /* Primera pagina de una visita pagada: retener */
  ssSet('mp_hw_no', '1');
  ssSet('mp_hw_hold', '1');
  var liberado = false;
  function liberar() {
    if (liberado) return;
    liberado = true;
    window.removeEventListener('scroll', onScroll);
    if (ss('mp_hw_hold') === '1') { ssDel('mp_hw_hold'); ssDel('mp_hw_no'); }
    setTimeout(function () {
      var abierto = document.querySelector('.mp-hw.is-open');
      if (!abierto && ss('mp_hw_no') !== '1' && ls('mp_hw_jugo') !== '1') juego.abrir();
    }, 800);
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight || 1;
    if ((window.pageYOffset + window.innerHeight) / h >= 0.5) liberar();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  setTimeout(liberar, 45000);
  window.addEventListener('pagehide', function () {
    if (!liberado && ss('mp_hw_hold') === '1') { ssDel('mp_hw_hold'); ssDel('mp_hw_no'); }
  });
})();
